import HTTP from '@/api/HTTP';
import transformerEmplacement
  from '@/services/gabed/emplacement/filter/emplacementServerTableDataTransformer';

const URL_BASE = 'patri/Emplacement/';

export async function getAll(emplacementFilter) {
  const inputServer = transformerEmplacement(emplacementFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function get(emplacementId) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: emplacementId } });
  return response;
}

export async function getAllWithDispositifMaterielFaceAsync(emplacementFilter) {
  const inputServer = transformerEmplacement(emplacementFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllWithDispositifMaterielFaceAsync', inputServer);
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function supprimer(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}
